import { render, staticRenderFns } from "./NotificationDetail.vue.js?vue&type=template&id=d8a6e012!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationDetail.vue?vue&type=template&id=d8a6e012"
import script from "./NotificationDetail.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports